import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-productions',
  templateUrl: './productions.component.html',
  styleUrls: ['./productions.component.css']
})
export class ProductionsComponent implements OnInit {

  loaderShown=true;
  CardShown=false;
  output:any=[];
  next_output:any=[];
  count=0;
  New_count=0
  constructor(private productionService:ServiceService,private route: ActivatedRoute, private router: Router) {}

    //-------date formating-------------
  
    today: Date = new Date();
    pipe = new DatePipe('en-US');
    todayWithPipe:any= null;
    data = {
      fromdate: "",
      todate: "",
      status: "",
    }
    selectedTimeFrame="td"
    
    DateFormat(value:any){
    //-------date formating----------------------
    this.todayWithPipe = this.pipe.transform(value, 'MMM d, y, h:mm:ss a');
    return this.todayWithPipe
  
    }
//---production detail page----------------
    ProductionDetails(Id:any){
      this.router.navigateByUrl(('admin/production-details')); 
      this.productionService.SetProductionId(Id);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
//---function for click previous----------
clicks_previous(){
  if(this.New_count==0){
    return;
  }
  else{
    this.New_count=this.New_count-1;
    this.count=this.New_count; 
  }
 this.fetchData()

}
//-------function for click next-------
clicks_next(){
  this.count=this.count+1
   this.fetchData()

}
  ngOnInit(): void {
    this.fromToAuto()
  }

  fetchData() {
    const searchString = `&from_date=${this.data.fromdate}&to_date=${this.data.todate}`;
    this.productionService.GetProductionfilter(this.count,searchString).subscribe((res)=>{
      this.output=res.data
      this.loaderShown=false;
      this.CardShown=true;
      })
  }

  fromToAuto() {
  console.log(this.selectedTimeFrame)
  const date = new Date();

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  let currentDate = `${year}-${month}-${day}`;
  switch (this.selectedTimeFrame) {
    case 'td':
      this.data.fromdate = this.formatDate(date)
      this.data.todate = this.formatDate(date)

      break;
    case 'ys':
      date.setDate(date.getDate() - 1);
      this.data.fromdate = this.formatDate(date);
      this.data.todate = this.formatDate(date);
      break;
    case 'lw':
      const lastWeekStartDate = new Date(date);
      const lastWeekEndDate = new Date(date);
      lastWeekStartDate.setDate(date.getDate() - date.getDay() - 6);
      lastWeekEndDate.setDate(date.getDate() - date.getDay());
      this.data.fromdate = this.formatDate(lastWeekStartDate);
      this.data.todate = this.formatDate(lastWeekEndDate);
      break
    case "tm":
      const tmfirst = new Date(date);
      tmfirst.setMonth(tmfirst.getMonth());

      const tmfirstDay = new Date(tmfirst.getFullYear(), tmfirst.getMonth(), 1);
      this.data.fromdate = this.formatDate(tmfirstDay);
      this.data.todate = this.formatDate(date)
      break
    case 'lm':

      const lastMonth = new Date(date);
      lastMonth.setMonth(lastMonth.getMonth() - 1);

      const firstDay = new Date(lastMonth.getFullYear(), lastMonth.getMonth(), 1);
      const lastDay = new Date(lastMonth.getFullYear(), lastMonth.getMonth() + 1, 0);
      this.data.fromdate = this.formatDate(firstDay);
      this.data.todate = this.formatDate(lastDay);
      console.log("fd", firstDay, 'ld', lastDay)
      break
    case 'ty':
      const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
      this.data.fromdate = this.formatDate(firstDayOfYear);
      this.data.todate = this.formatDate(date)
      break
    case 'al':
      this.data.fromdate = '';
      this.data.todate = '';
      break
    default:
    // code block
  }
  this.fetchData()
}
formatDate(date: Date): string {
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  return `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
}



}
